import { render, staticRenderFns } from "./FilterByPrice.vue?vue&type=template&id=1507a8eb&"
import script from "./FilterByPrice.vue?vue&type=script&lang=js&"
export * from "./FilterByPrice.vue?vue&type=script&lang=js&"
import style0 from "./FilterByPrice.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports